export enum UserActionTypes {
  GET_USER_DATA = "GET_USER_DATA",

  SET_USER_DSTISO_CURRENT = "SET_USER_DSTISO_CURRENT",
  SET_USER_FLYOUT_LOGIN_MSG = "SET_USER_FLYOUT_LOGIN_MSG",
  SET_USER_DATA = "SET_USER_DATA",
}
